namespace GeniuzPOS.Purchase {
    export interface PoPo05PendingPIforIrRow {
        SysDocNo?: string;
        UseFg?: number;
        PurIvNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        SupplierId?: string;
        SupplName?: string;
        ShipId?: string;
        ShipDate?: string;
        PayTermCode?: string;
        WhsId?: string;
        ReceiptAmt?: number;
        Remark?: string;
        DtList?: PoPo05DtPendingPIforIrRow[];
    }

    export namespace PoPo05PendingPIforIrRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPo05PendingPIforIr';
        export const lookupKey = 'Purchase.PoPo05PendingPIforIr';

        export function getLookup(): Q.Lookup<PoPo05PendingPIforIrRow> {
            return Q.getLookup<PoPo05PendingPIforIrRow>('Purchase.PoPo05PendingPIforIr');
        }
        export const deletePermission = '5Purchase:รายงาน:รายงานใบรับสินค้าคงค้าง:View';
        export const insertPermission = '5Purchase:รายงาน:รายงานใบรับสินค้าคงค้าง:View';
        export const readPermission = '5Purchase:รายงาน:รายงานใบรับสินค้าคงค้าง:View';
        export const updatePermission = '5Purchase:รายงาน:รายงานใบรับสินค้าคงค้าง:View';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            UseFg = "UseFg",
            PurIvNo = "PurIvNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            ShipId = "ShipId",
            ShipDate = "ShipDate",
            PayTermCode = "PayTermCode",
            WhsId = "WhsId",
            ReceiptAmt = "ReceiptAmt",
            Remark = "Remark",
            DtList = "DtList"
        }
    }
}
